import env from "@beam-australia/react-env"
import axios from "axios"
import { FormikConfig, FormikValues } from "formik"
import { SubmissionObject } from "../model"
import { basicValidationSchema } from "./validation"
import { splitNames, filterCookies, filterQueryString, mergeMarketingObjects, generateSourceName } from "../functions"
import { GRecaptcha } from "../../modules/recaptcha"

export const formikConfig: FormikConfig<FormikValues> = {
    initialValues: {
        name: undefined,
        position: undefined,
        workphone: undefined,
        orgname: undefined,
        website: undefined,
        email: undefined,
        source: undefined,
        mx: true,
    },
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: basicValidationSchema,
    onSubmit: (values) => {
        return new Promise(function (resolve, reject) {
            GRecaptcha.execute(env("RECAPTCHA_SITE_KEY"), { action: "submit" }).then((gRecaptchaResponse) => {
                const url = `${env("PARTNER_API")}/api/websiteLead?mx=${values.mx}`
                const payload: SubmissionObject = {
                    firstName: splitNames(values.name).first,
                    lastName: splitNames(values.name).last,
                    jobTitle: values.position,
                    businessPhone: values.workphone,
                    businessName: values.orgname,
                    businessEmail: values.email,
                    numberOfPeople: values.count,
                    interests: values.interests,
                    leadSource: generateSourceName(values.source, values.location),
                    referrer: window.document.referrer,
                    recaptchaToken: gRecaptchaResponse,
                    ...mergeMarketingObjects(filterQueryString(window.location.search), filterCookies(document.cookie)),
                }
                axios
                    .put(url, payload)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        })
    },
}
